import React from 'react';
import { ThemeMode } from '../types';

interface BackgroundDotsProps {
  theme: ThemeMode;
}

export const BackgroundDots: React.FC<BackgroundDotsProps> = ({ theme }) => {
  const isDark = theme === 'dark';

  return (
    <div className="absolute inset-0 pointer-events-none overflow-hidden z-0 select-none">
      {/* Top subtle ambient glow */}
      <div 
        className={`absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[380px] rounded-full blur-[120px] transition-opacity duration-500 ${
          isDark ? 'bg-purple-900/40 opacity-40' : 'bg-gradient-to-r from-purple-300/40 via-indigo-200/40 to-sky-300/50 opacity-80'
        }`} 
      />
      
      {/* Curved SVG Dotted Matrix Wave */}
      <svg 
        className={`absolute top-0 left-0 w-full h-[600px] transition-opacity duration-300 ${
          isDark ? 'text-purple-500 opacity-25 sm:opacity-40' : 'text-purple-600 opacity-35 sm:opacity-55'
        }`}
        xmlns="http://www.w3.org/2000/svg" 
        width="100%" 
        height="100%"
      >
        <defs>
          <pattern id="dotGrid" width="24" height="24" patternUnits="userSpaceOnUse">
            <circle cx="2" cy="2" r="1" fill="currentColor" />
          </pattern>
          <linearGradient id="fadeMask" x1="0%" y1="0%" x2="0%" y2="100%">
            <stop offset="0%" stopColor="white" stopOpacity="0.8" />
            <stop offset="80%" stopColor="white" stopOpacity="0.1" />
            <stop offset="100%" stopColor="white" stopOpacity="0" />
          </linearGradient>
          <mask id="dotsMask">
            <rect width="100%" height="100%" fill="url(#fadeMask)" />
          </mask>
        </defs>
        <rect width="100%" height="100%" fill="url(#dotGrid)" mask="url(#dotsMask)" />
      </svg>
    </div>
  );
};
